import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, ActivatedRoute } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';
import jwt_decode from "jwt-decode";


@Injectable({
  providedIn: 'root'
})
export class CashRegisterGuard  {

  constructor(private activatedRouter: ActivatedRoute, private router: Router, private authenticationService: AuthenticationService) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot) {
      if(localStorage.getItem('id_cash_register')===null){
        this.router.navigateByUrl("/")
        return false;
      }
      return true;
    }
}
